import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "explorer",
  class: "!pb-0"
}
const _hoisted_2 = { class: "relative z-10 w-full flex flex-col items-center justify-start space-y-4" }
const _hoisted_3 = { class: "relative rotate-180 transform" }
const _hoisted_4 = { class: "relative w-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "absolute top-0 left-0 w-8 lg:w-32 h-full bg-gradient-to-r from-black z-20 pointer-events-none" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "absolute top-0 right-0 w-8 lg:w-32 h-full bg-gradient-to-l from-black z-20 pointer-events-none" }, null, -1)
const _hoisted_7 = { class: "relative" }

import TokenCard from "@/components/token/TokenCard.vue";
import { EffectCoverflow, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import { tokens } from "@/constants";
import ArrowUp from "@/components/icons/ArrowUp.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeExplorer',
  setup(__props) {

const modules = [EffectCoverflow, Autoplay] as any[];

return (_ctx: any,_cache: any) => {
  const _directive_animate = _resolveDirective("animate")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ArrowUp, { class: "text-neutral-50/50 w-3 h-3 md:w-4 md:h-4" })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Swiper), {
          effect: 'coverflow',
          modules: _unref(modules),
          autoplay: {
                        delay: 750,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: false,
                    },
          coverflowEffect: {
                        rotate: 0,
                        modifier: 2.6,
                        stretch: 0,
                        scale: 0.99,
                        stretch: 1,
                        slideShadows: false,
                    },
          centeredSlides: true,
          loop: "",
          allowTouchMove: false,
          breakpoints: {
                        0: {
                            slidesPerView: 2,
                        },
                        640: {
                            slidesPerView: 3,
                        },
                        768: {
                            slidesPerView: 3,
                        },
                        1024: {
                            slidesPerView: 4,
                        },
                        1280: {
                            slidesPerView: 5,
                        },
                        1536: {
                            slidesPerView: 6,
                        },
                    }
        }, {
          "container-start": _withCtx(() => [
            _hoisted_5
          ]),
          "container-end": _withCtx(() => [
            _hoisted_6
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tokens).all, (token, i) => {
              return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                ref_for: true,
                ref: "slideRef",
                key: i
              }, {
                default: _withCtx(() => [
                  _createVNode(TokenCard, { token: token }, null, 8, ["token"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["modules", "coverflowEffect"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(ArrowUp, { class: "text-neutral-50/50 block w-3 h-3 md:w-4 md:h-4" })
      ])
    ])), [
      [_directive_animate]
    ])
  ]))
}
}

})